/**************************************************
 * Nombre:       Dona_Limpia
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import Chart from "react-apexcharts";
import {COLORES} from "../ContantesColorGraficas";
import {useEffect, useState} from "react";

const Dona_Limpia = ({
                         ancho,
                         labels = [],
                         series = [],
                         marginTop = 0,
                         height = 'auto',
                         colores = COLORES,
                         defAncho = '60%'
                     }) => {
    const [ancho_, setAncho_] = useState(defAncho)

    const options = {
        chart: {
            id: "basic-bar",
            sparkline: {
                enabled: true,
            },
        },
        labels: labels,
        stroke: {
            width: 0
        },
        tooltip: {
            enabled: true,
            custom: function({series, seriesIndex, dataPointIndex, w}) {
                const customElement = document.createElement('div')
                customElement.style.padding = '10px'
                customElement.innerHTML =`${labels[seriesIndex]}: ${series[seriesIndex]} USD`
                return customElement
            }
        },
        colors: colores,
    }


    useEffect(() => {
        setAncho_(ancho)
    }, [ancho]);
    return (
        <Chart
            options={options}
            series={series}
            type="donut"
            width={ancho_}
            height={height}
            style={{marginTop: marginTop, color: '#000'}}
        />
    )

}
export default Dona_Limpia